<div class="app-header header sticky desktop-view">
  <div class="container-fluid">
    <div class="d-flex align-items-center justify-content-between mobile-header">
      <a class="header-brand" routerLink="/">
        <img src="../../../../assets/images/brand/logo.png" class="header-brand-img desktop-logo" alt="header-logo" width="200" height="38" />
      </a>
      <button class="hamburger" (click)="toggleMenu()">
        <span class="hamburger-icon">
          <div [innerHTML]="ICONS.menuIcon | safeHtml"></div>
        </span>
      </button>
      <div *ngIf="userLoggedIn; else showLogin" class="profile_section_mob">
        <!-- Profile Section -->
        <button class="imgdrpdown" ngbDropdown>
          <img
            ngbDropdownToggle
            data-bs-toggle="dropdown"
            [src]="userInfo?.profilePicture ? fileDirectoriesPath + userInfo?.profilePicture : 'assets/images/img_profile.png'"
            alt=""
            class="profile-pic"
            width="36"
            height="36"
          />
          <!-- <img ngbDropdownToggle data-bs-toggle="dropdown" src="../../../../assets/images/ic_drop_down.svg" alt="dropdown-icon" class="m-l-5" /> -->
          <span
            class="m-l-5 dropicon"
            ngbDropdownToggle
            data-bs-toggle="dropdown"
            role="button"
            [innerHTML]="ICONS.dropdownIcon | safeHtml"
            role="button"
            aria-label="User menu"
          ></span>
          <div ngbDropdownMenu class="dropdown-menu dropdown-menu-end">
            <ul ngbDropdownItem class="viewMoreItem">
              <li>
                <a ngbDropdownItem routerLink="/my/feed">
                  <!-- <img src="../../../../assets/images/ic_feed.svg" width="18" height="18" alt="my-feed" /> -->

                  <div [innerHTML]="ICONS.myFeed | safeHtml"></div>
                  <span>My feed</span>
                </a>
              </li>
              <li>
                <a ngbDropdownItem routerLink="/my/orders">
                  <!-- <img src="../../../../assets/images/ic_order.svg" width="18" height="18" alt="my-orders" /> -->
                  <div [innerHTML]="ICONS.orderIcon | safeHtml"></div>
                  <span>My orders</span>
                </a>
              </li>
              <li>
                <a ngbDropdownItem routerLink="/my/account-settings">
                  <!-- <img src="../../../../assets/images/ic-settings.svg" width="18" height="18" alt="account-setting" /> -->
                  <div [innerHTML]="ICONS.settingIcon | safeHtml"></div>
                  <span>Account settings</span>
                </a>
              </li>
              <li>
                <button class="logoutlink" ngbDropdownItem (click)="logout()">
                  <!-- <img src="../../../../assets/images/ic-logout.svg" width="18" height="18" alt="logout" /> -->
                  <span [innerHTML]="ICONS.logoutIcon | safeHtml"></span>
                  <span>Logout</span>
                </button>
              </li>
            </ul>
          </div>
        </button>
      </div>

      <!-- Login Button for Non-Logged-In Users -->
      <ng-template #showLogin>
        <a class="common--button_login" routerLink="/auth/login">Login</a>
      </ng-template>

      <div class="header-menu mobile-menu" [class.active]="menuOpen">
        <nav class="menus">
          <ul>
            <li *ngIf="userLoggedIn && menuOpen" class="menuSearch">
              <a (click)="searchOpen()" class="search-item"
                ><img src="../../../../assets/images/ic_search.svg" alt="Search" class="search-icon" />
                <h4 class="search-text">Search</h4>
              </a>
            </li>
            <li class="menu__item" [ngClass]="{ tooltipArrow: showTooltip && currentStep === 1 }">
              <a
                [routerLink]="sportsRoute"
                (click)="userInfo?.id ? '' : screenWidth > 990 ? '' : onExploreClick($event, 'sports')"
                (mouseover)="toggleMenuOpen(true)"
                >Sports</a
              >
              <div *ngIf="showTooltip && currentStep === 1" class="{{ showTooltip && currentStep === 1 ? 'tooltip-overlay' : '' }}"></div>
              <div *ngIf="showTooltip && currentStep === 1" class="custom-tooltip">
                <h4 class="tooltip-heading">Sports</h4>
                <p class="tooltip-description">
                  Discover and learn about various XDGE sports, view details, and access related features on this page.
                </p>
                <button class="skip-all-button" (click)="onSkipAll()">Skip All</button>
                <button class="nxt-button" (click)="onNextClick()">Next</button>
                <span class="tooltip-step">{{ currentStep }} / 5</span>
              </div>
            </li>
            <li class="menu__item" [ngClass]="{ tooltipArrow: showTooltip && currentStep === 2 }">
              <a
                [routerLink]="userInfo?.id ? '/feed' : null"
                (click)="userInfo?.id ? '' : onExploreClick($event, 'feed')"
                (mouseover)="toggleMenuOpen(false)"
                >Feed</a
              >
              <div *ngIf="showTooltip && currentStep === 2" class="{{ showTooltip && currentStep === 2 ? 'tooltip-overlay' : '' }}"></div>
              <div *ngIf="showTooltip && currentStep === 2" class="custom-tooltip">
                <h4 class="tooltip-heading">Feed</h4>
                <p class="tooltip-description">
                  Discover all the new feeds posted by others. Review and rate the feeds that align with your preferred sports.
                </p>
                <button class="skip-all-button" (click)="onSkipAll()">Skip All</button>
                <button class="nxt-button" (click)="onNextClick()">Next</button>
                <span class="tooltip-step">{{ currentStep }} / 5</span>
              </div>
            </li>
            <li class="menu__item" [ngClass]="{ tooltipArrow: showTooltip && currentStep === 3 }">
              <a
                [routerLink]="userInfo?.id ? '/events/eventByOthers' : null"
                (click)="userInfo?.id ? '' : onExploreClick($event, 'event')"
                (mouseover)="toggleMenuOpen(false)"
                >Events</a
              >
              <div *ngIf="showTooltip && currentStep === 3" class="{{ showTooltip && currentStep === 3 ? 'tooltip-overlay' : '' }}"></div>
              <div *ngIf="showTooltip && currentStep === 3" class="custom-tooltip">
                <h4 class="tooltip-heading">Events</h4>
                <p class="tooltip-description">
                  Explore all the events happening near you related to your favorite sport. You can also post your own event here.
                </p>
                <button class="skip-all-button" (click)="onSkipAll()">Skip All</button>
                <button class="nxt-button" (click)="onNextClick()">Next</button>
                <span class="tooltip-step">{{ currentStep }} / 5</span>
              </div>
            </li>
            <li class="menu__item" [ngClass]="{ tooltipArrow: showTooltip && currentStep === 4 }">
              <a routerLink="/leaderboard" (mouseover)="toggleMenuOpen(false)">Leaderboard</a>
              <div *ngIf="showTooltip && currentStep === 4" class="{{ showTooltip && currentStep === 4 ? 'tooltip-overlay' : '' }}"></div>
              <div *ngIf="showTooltip && currentStep === 4" class="custom-tooltip">
                <h4 class="tooltip-heading">Leaderboard</h4>
                <p class="tooltip-description">Check the leaderboard to stay updated on your current level and rank, as well as those of others.</p>
                <button class="skip-all-button" (click)="onSkipAll()">Skip All</button>
                <button class="nxt-button" (click)="onNextClick()">Next</button>
                <span class="tooltip-step">{{ currentStep }} / 5</span>
              </div>
            </li>
            <li class="menu__item" [ngClass]="{ tooltipArrow: showTooltip && currentStep === 5 }">
              <a
                [routerLink]="userInfo?.id ? '/store' : null"
                (click)="userInfo?.id ? '' : onExploreClick($event, 'XDGE Store')"
                (mouseover)="toggleMenuOpen(false)"
                >XDGE Store</a
              >
              <div *ngIf="showTooltip && currentStep === 5" class="{{ showTooltip && currentStep === 5 ? 'tooltip-overlay' : '' }}"></div>
              <div *ngIf="showTooltip && currentStep === 5" class="custom-tooltip">
                <h4 class="tooltip-heading">XDGE Store</h4>
                <p class="tooltip-description">Shop premium sports products at XDGE store, offering top-quality gear to enhance your performance.</p>
                <button class="skip-all-button" (click)="onSkipAll()">Skip All</button>
                <button class="nxt-button" (click)="onNextClick()">Done</button>
                <span class="tooltip-step">{{ currentStep }} / 5</span>
              </div>
            </li>
          </ul>
        </nav>
      </div>
      <div class="header-menu header-menu-settings">
        <nav class="setting__menu">
          <ul *ngIf="userLoggedIn; else registerShow">
            <li class="search-item-list">
              <button class="search-item handPointer" (click)="searchOpen()">
                <div class="listIcon" [innerHTML]="ICONS.searchIcon | safeHtml"></div>
              </button>
            </li>
            <li>
              <button class="handPointer carticon" (click)="storeRedirect()">
                <div class="listIcon" [innerHTML]="ICONS.cartIcon | safeHtml"></div>

                @if (shopifyCart > 0) {
                  <span class="cartCounter"
                    ><b>{{ shopifyCart }}</b></span
                  >
                }
              </button>
            </li>
            <li>
              <button class="notiBtn handPointer {{ unreadNotificationsCount > 0 ? 'notification-unread' : '' }}" (click)="NotificationsOpen()">
                <div class="listIcon" [innerHTML]="ICONS.notificationIcon | safeHtml"></div>
              </button>
            </li>
            <li class="location_wrapper">
              <button
                class="locationBtn handPointer"
                [ngbPopover]="popContent"
                popoverClass="location__popover"
                [class.popover-open]="isPopoverOpen"
                triggers="click"
                autoClose="outside"
                placement="bottom"
                (shown)="isPopoverOpen = true"
                (hidden)="isPopoverOpen = false"
                #popoverRef="ngbPopover"
              >
                <div
                  class="listIcon"
                  [class.selected_location]="selectedLocation != '' && selectedLocation != undefined"
                  [innerHTML]="ICONS.locationIcon | safeHtml"
                ></div>
              </button>

              <ng-template #popContent>
                <h4>Select your preferred location</h4>
                <div class="custom-select-wrapper">
                  <div class="locSearchWrap position-relative">
                    <div class="locSearchIcon" (click)="getCurrentLocation()" [innerHTML]="ICONS.locationSearchIcon | safeHtml"></div>
                    <ng-select
                      [searchable]="true"
                      class="form-control"
                      [clearable]="false"
                      placeholder="Select"
                      [(ngModel)]="selectedLocation"
                      bindLabel="title"
                      (search)="onSearchInputChange($event)"
                      (change)="select($event)"
                      tabindex="0"
                    >
                      <!-- <ng-template ng-option-tmp let-item="item" *ngFor="let item of suggestions">
                        <p class="mb-0 fw-bold">{{ item?.structured_formatting?.main_text || '--' }}</p>
                        <small class="text-muted">{{ item?.structured_formatting?.secondary_text || '--' }}</small>
                      </ng-template> -->

                      <ng-option *ngFor="let data of suggestions" [value]="data">
                        <p class="mb-0 fw-bold" [class.invalid-feedback]="data?.main_text == selectedLocation">
                          {{ data?.main_text || data?.name || '' }}
                        </p>
                        <small class="text-muted">{{ data?.secondary_text || '' }}</small>
                      </ng-option>
                    </ng-select>
                  </div>
                </div>
              </ng-template>
            </li>
            <li>
              <div class="profile_section">
                <button class="imgdrpdown" ngbDropdown placement="bottom-end" #dropdownRef="ngbDropdown">
                  <img
                    ngbDropdownToggle
                    data-bs-toggle="dropdown"
                    [src]="userInfo?.profilePicture ? fileDirectoriesPath + userInfo?.profilePicture : 'assets/images/img_profile.png'"
                    alt="Profile Image"
                    class="profile-pic"
                    width="36"
                    height="36"
                  />
                  <span class="profile-userinfo" role="button" ngbDropdownToggle data-bs-toggle="dropdown">{{ userInfo?.name || '--' }}</span>

                  <span
                    class="m-l-5 dropicon"
                    ngbDropdownToggle
                    data-bs-toggle="dropdown"
                    role="button"
                    [innerHTML]="ICONS.dropdownIcon | safeHtml"
                    role="button"
                    aria-label="User menu"
                  ></span>

                  <div ngbDropdownMenu class="dropdown-menu dropdown-menu-end">
                    <ul ngbDropdownItem class="viewMoreItem">
                      <li>
                        <a ngbDropdownItem routerLink="/my/feed">
                          <div [innerHTML]="ICONS.myFeed | safeHtml"></div>
                          <span>My feed</span>
                          <!-- <div [innerHTML]="home1 | safeHtml"></div> -->
                        </a>
                      </li>
                      <li>
                        <a ngbDropdownItem routerLink="/my/orders">
                          <div [innerHTML]="ICONS.orderIcon | safeHtml"></div>
                          <span>My orders</span>
                        </a>
                      </li>
                      <li>
                        <a ngbDropdownItem routerLink="/my/account-settings">
                          <div [innerHTML]="ICONS.settingIcon | safeHtml"></div>
                          <span>Account settings</span>
                        </a>
                      </li>
                      <li>
                        <button class="logoutlink" ngbDropdownItem (click)="logout()">
                          <span [innerHTML]="ICONS.logoutIcon | safeHtml"></span>
                          <span>Logout</span>
                        </button>
                      </li>
                    </ul>
                  </div>
                </button>
              </div>
            </li>
          </ul>
          <ng-template #registerShow>
            <ul>
              <li>
                <a class="common--button_unfill" routerLink="/auth/login">Login</a>
              </li>
              <li>
                <a class="common--button_unfill" routerLink="/auth/signup">Register</a>
              </li>
            </ul>
          </ng-template>
        </nav>
      </div>
    </div>

    <!-- sports subMenu -->
    <!-- <div class="subMenu" *ngIf="showMenu" (mouseleave)="toggleMenuOpen(false)"></div> -->
    <div class="subMenu" (mouseleave)="toggleMenuOpen(false)" [ngClass]="{ active: showMenu }">
      <div class="subMenu_mobileHeader">
        <h2 [routerLink]="userInfo?.id ? '/sports' : null">Sports</h2>

        <div class="close__SubMenu" (click)="toggleMenuOpen(false)" [innerHTML]="ICONS.closeCircleIcon | safeHtml"></div>
      </div>
      <div class="subMenu__row" ngbAccordion [closeOthers]="screenWidth < 991 ? true : false">
        <div class="subMenu__col" ngbAccordionItem [collapsed]="screenWidth < 991 ? true : false" *ngFor="let data of sportList; let i = index">
          <div class="subMenu__col__heading" ngbAccordionHeader>
            <img
              src="{{
                i % 4 == 0
                  ? '../../../../assets/images/img_water.png'
                  : i % 4 == 1
                    ? '../../../../assets/images/img_earth.png'
                    : i % 4 == 2
                      ? '../../../../assets/images/img_snow-ice.png'
                      : '../../../../assets/images/img_air.png'
              }}"
              alt="{{ data?.name }}"
            />
            <h2>
              <button ngbAccordionButton>{{ data?.name }}</button>
            </h2>
          </div>
          <div class="subMenu__col__menuList" ngbAccordionCollapse>
            <ul>
              <li *ngFor="let item of data.allSports">
                <a
                  [routerLink]="userInfo?.id ? '/sports/' + item.id : null"
                  (click)="userInfo?.id ? toggleMenuOpen(false) : onExploreClick($event, 'sports')"
                  >{{ item.name }}</a
                >
              </li>
            </ul>
            <!-- <a
              *ngIf="data.totalAllSportsCount > 6"
              [routerLink]="userInfo?.id ? '/sports' : null"
              (click)="userInfo?.id ? (toggleMenuOpen(false)) : onExploreClick($event, 'sports')"
              [queryParams]="{ element: data.name }"
              class="view-menuLink"
              >view More</a
            > -->
          </div>
        </div>
      </div>
    </div>
    <!-- //sports subMenu -->
  </div>
</div>
